// src/components/typography/typographyStyles.tsx
import { css } from "@emotion/react";
var typographyStyles = ({
  /* theme, size, colorProp, */
  block: blockProp,
  hideOverflow,
  displayProp,
  textAlign,
  onClick
}) => {
  const displayValue = blockProp || hideOverflow ? "block" : displayProp || null;
  return css`
    /* Margins should always be set in parent style contexts eg Article: */
    margin: 0;

    ${typeof onClick === "function" ? "cursor: pointer;" : ""}
    ${textAlign ? `text-align: ${textAlign};` : ""}
    ${displayValue ? `display: ${displayValue};` : ""}
    ${hideOverflow ? "overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;" : ""}
  `;
};

export {
  typographyStyles
};
